module.exports = __webpack_public_path__ + "img/3c-transfer.2e424170.png";